'use strict';
import * as $j_java$002elang$002e$002dInterrupted$002dException from "./java.lang.-Interrupted-Exception.js";
import * as $j_java$002elang$002e$002dLinkage$002dError from "./java.lang.-Linkage-Error.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002elang$002e$002dThread$002dDeath from "./java.lang.-Thread-Death.js";
import * as $j_java$002elang$002e$002dVirtual$002dMachine$002dError from "./java.lang.-Virtual-Machine-Error.js";
import * as $j_scala$002eutil$002econtrol$002e$002dControl$002dThrowable from "./scala.util.control.-Control-Throwable.js";
var $p;
/** @constructor */
function $c_s_util_control_NonFatal$() {
}
export { $c_s_util_control_NonFatal$ as $c_s_util_control_NonFatal$ };
$p = $c_s_util_control_NonFatal$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
}
export { $h_s_util_control_NonFatal$ as $h_s_util_control_NonFatal$ };
$h_s_util_control_NonFatal$.prototype = $p;
$p.Sp = (function(t) {
  matchAlts1: {
    matchAlts2: {
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  return true;
});
$p.ht = (function(t) {
  return (this.Sp(t) ? new $j_java$002elang$002e$002dObject.$c_s_Some(t) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
var $d_s_util_control_NonFatal$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_control_NonFatal$, "scala.util.control.NonFatal$", ({
  wi: 1
}));
export { $d_s_util_control_NonFatal$ as $d_s_util_control_NonFatal$ };
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$();
  }
  return $n_s_util_control_NonFatal$;
}
export { $m_s_util_control_NonFatal$ as $m_s_util_control_NonFatal$ };
